import { defineSlotRecipe } from '@chakra-ui/react'

export const stickyBanner = defineSlotRecipe({
  className: 'StickyBanner',
  slots: ['banner', 'container', 'crossIcon', 'message', 'messageWrapper', 'wrapper', 'icon'],
  base: {
    wrapper: { backgroundColor: 'brand.baseGray.10' },
    banner: {},
    icon: { color: 'brand.highlight.blue' },
    message: {
      color: 'brand.primary.midnightBlue',
    },
    crossIcon: {
      mr: 3,
    },
  },
  variants: {
    variant: {
      ERROR: {
        wrapper: {
          borderColor: 'brand.alertPink',
        },
        icon: {
          color: 'brand.alertPink',
        },
      },
      INFO: {
        wrapper: {
          borderColor: 'brand.highlight.blue',
        },
        icon: {
          color: 'brand.primary.midnightBlue',
        },
      },
      SUCCESS: {
        wrapper: {
          borderColor: 'brand.confirmationGreen',
        },
        icon: {
          color: 'brand.confirmationGreen',
        },
      },
      WARNING: {
        wrapper: {
          borderColor: 'brand.primary.red',
        },
        icon: {
          color: 'brand.primary.red',
        },
      },
      PROMOTION: {
        wrapper: {
          backgroundColor: '#FAFAFA',
        },
      },
    },
  },
})
